"use strict";
/**
 * ************************************
 *
 * @module next-persist
 * @author most-js
 * @description module that contains function to write state to cookies
 *
 * ************************************
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCookieStore = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
function setCookieStore(config, state) {
    var key = Object.keys(config)[0];
    var allowList = Object.values(config)[0];
    // if allowList was not defined in cookieConfig, sets cookie containing entire state
    if (allowList.length === 0) {
        js_cookie_1.default.set(key, JSON.stringify(state), { expires: 365 });
    }
    else {
        // sets cookie containing only properties listed in allowList
        var allowedState = allowList.reduce(function (acc, cur) {
            acc[cur] = state[cur];
            return acc;
        }, {});
        js_cookie_1.default.set(key, JSON.stringify(allowedState), { expires: 365 });
    }
}
exports.setCookieStore = setCookieStore;
